export const scrollToForm = ()=> {
    const formEl = document.getElementById('main-section-form');
    window.scrollTo({top: formEl.offsetTop+152, behavior: 'smooth'});
}
